const css = require('./help.css');
let { cut } = require('../../helpers/utils');
const COLLAPSER_SELECTOR = cut(css.collapserHead);
const Prices = require('../common/prices');
const Discounts = require('../common/discounts');
const bitrix = require('../../signals/bitrix');
let { redirect } = require('../../signals/utils');

class Help {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [COLLAPSER_SELECTOR]: this.collapserClick,
                [cut(css.redirect)]: this.redirect
            }
        };
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }

    collapserClick (e) {
        let classList = e.currentTarget.parentNode.classList;
        // добавляем/удаляем класс clicked
        if (!classList.contains(css.clicked)) {
            classList.add(css.clicked);
        } else {
            classList.remove(css.clicked);
        }
        this.$context.signal(bitrix.resize);
    }
}

module.exports = {
    constructor: Help,
    children: [
        {
            name: 'prices',
            component: Prices,
            watcher: {
                prices: ['data', 'computed', 'prices']
            }
        },
        {
            name: 'discounts',
            component: Discounts,
            watcher: {
                prices: ['data', 'computed', 'discounts']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/help/index.js